export const jurosCorrecaoSectionKeys = [
    "indexadorCorrecaoPercentual",
    "defasagem",
    "calculoDiasIndexador",
    "formulaIndexador",
    "calculoDias",
    "jurosCapitalizacao",
    "periodicidadeAtualizacaoMonetaria",
    "mesAniversarioAnualSEmestral",
    "projecaoInflacao",
    "inflacaoNegativa",
    "recalculoProjecao",
    "aplicacaoAmortizacao",
    "corrigeDataEvento",
]